<template>
  <widget
    :title="`${company.ragioneSociale} ${company.nome}`"
    icon="mdi-domain"
    :color="colors.primarycolor"
    :closeButton="false"
    :bgColor="colors.white"
  >
    <template v-slot:toolbar>
      <v-btn
        @click="
          $router.push({ name: 'company_detail', params: { id: company.id } })
        "
        icon
        small
        :color="colors.primarycolor"
        ><v-icon>mdi-pencil</v-icon></v-btn
      >
    </template>
    <v-row no-gutters class="px-2">
      <v-col cols="6">
        <div class="text-little">Partita iva: {{ company.partitaIva }}</div>
      </v-col>
      <v-col cols="6">
        <div class="text-little">
          Codice fiscale: {{ company.codiceFiscale }}
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="text-truncate text-formatter mb-1">Sede legale</div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-map-marker</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="
                  company.sLegIndirizzo +
                  ', ' +
                  company.sLegCap +
                  ' ' +
                  company.sLegComune +
                  ' (' +
                  company.sLegPr +
                  ')'
                "
              >
                {{ company.sLegIndirizzo }}<br />{{ company.sLegCap }}
                {{ company.sLegComune }} ({{ company.sLegPr }})
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-phone</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.sLegTelPref + ' - ' + company.sLegTelefono"
              >
                {{ company.sLegTelPref }} - {{ company.sLegTelefono }}
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-cellphone</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.sLegCellulare"
              >
                {{ company.sLegCellulare }}
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-email</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.email"
              >
                {{ company.email }}
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon size="32" :color=" company.sLegPec ? colors.primarycolor : '#F44336'">{{ path }}</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.sLegPec"
              >
                {{ company.sLegPec }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-col cols="12">
            <div  class="text-formatter text-truncate mb-1">Sede operativa</div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-map-marker</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="
                  company.ubicIndirizzo +
                  ', ' +
                  company.ubicCap +
                  ' ' +
                  company.ubicComune +
                  ' (' +
                  company.ubicPr +
                  ')'
                "
              >
                {{ company.ubicIndirizzo }}<br />
                {{ company.ubicCap }} {{ company.ubicComune }} ({{
                  company.ubicPr
                }})
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-phone</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.ubicTelPref + ' - ' + company.ubicTelefono"
              >
                {{ company.ubicTelPref }} - {{ company.ubicTelefono }}
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-cellphone</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.ubicCellulare"
              >
                {{ company.ubicCellulare }}
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-flex flex-row" style="overflow: hidden">
              <v-icon :color="colors.primarycolor" left>mdi-email</v-icon>
              <div
                class="text-truncate text-little mb-1"
                :title="company.ubicEmail"
              >
                {{ company.ubicEmail }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";
import Widget from "./Widget.vue";
import { mdiEmailSeal } from '@mdi/js';
export default {
  name: "company-detail",
  mixins: [mixin],
  components: {
    Widget,
  },
  data() {
    return {
       path: mdiEmailSeal,
    }
  },
  mounted() {
    this.fetchCompany();
  },
  methods: {
    ...mapActions({
      fetchCompany: "widget/fetchCompany",
    }),
  },
  computed: {
    ...mapGetters({
      company: "widget/company",
    }),
  },
};
</script>

<style scoped>
</style>